
import { Card, CardContent } from "@/components/ui/card";
import { useProductStatistics } from "@/hooks/useProductStatistics";

interface ProductListStatsProps {
  orderId: string;
  searchQuery?: string;
  posStatusFilter?: 'all' | 'new' | 'existing';
}

export const ProductListStats = ({ orderId, searchQuery, posStatusFilter }: ProductListStatsProps) => {
  const { data: stats, isLoading, error } = useProductStatistics(orderId, searchQuery, posStatusFilter);

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3 mb-4">
        <Card className="border-0 shadow-sm">
          <CardContent className="p-3 text-center">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-2"></div>
            <p className="text-xs text-gray-600">Loading...</p>
          </CardContent>
        </Card>
        <Card className="border-0 shadow-sm">
          <CardContent className="p-3 text-center">
            <div className="h-6 bg-gray-200 rounded animate-pulse mb-2"></div>
            <p className="text-xs text-gray-600">Loading...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (error) {
    console.error('Error loading product statistics:', error);
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-3 mb-4">
      <Card className="border-0 shadow-sm">
        <CardContent className="p-3 text-center">
          <div className="text-lg font-bold text-blue-600">{stats?.filteredCount || 0}</div>
          <p className="text-xs text-gray-600">Filtered Products</p>
        </CardContent>
      </Card>
      <Card className="border-0 shadow-sm">
        <CardContent className="p-3 text-center">
          <div className="text-lg font-bold text-green-600">{stats?.filteredBoxes || 0}</div>
          <p className="text-xs text-gray-600">Filtered Boxes</p>
        </CardContent>
      </Card>
    </div>
  );
};
